import React from "react";
import { connect } from "react-redux";

import { CustomIcon, Switch, } from "../widgets";
import HelpIcon from "signoxe/images/help-icon.png";
import Cancel from "signoxe/images/cancel.png";

import "./style.scss";
import { callOnEnter } from "signoxe/utils/eventHelpers";
import { updateContentFeed } from "signoxe/actions";
import Icon from "../widgets/Icon/index";
import SelectSearch from "../widgets/SelectSearch";
import { getProfile } from "signoxe/selectors";
import { deviceGroup } from "signoxe/api/schema";

class PlaylistCondition extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      buttonEnable: false,
      helpButton: false,
      freq: null,
      no_item_play: null,
      max_play: null,
      startHour: "",
      startMin: "",
      endHour: "",
      endMin: "",
      buttonVisible: false,
      loading: false,
      match_tags:false
    };

    document.addEventListener("click", function (event) {
      var ignore = document.getElementsByClassName("feed-list")[0];
      var popup = document.getElementsByClassName("playlist-conditions")[0];
      if (ignore && popup) {
        var isClick = ignore.contains(event.target);
        if (!isClick) {
          if(popup != undefined) popup.previousElementSibling.click();
        }
      }
      
    });
  }



  componentDidMount() {
    const { frequency, number_of_item_to_play, max_play_count, start_time, end_time, match_tags } =
      this.props.feed;
    this.setState({
      freq: frequency,
      no_item_play: number_of_item_to_play,
      max_play: max_play_count,
      startHour: start_time.split(":")[0],
      startMin: start_time.split(":")[1],
      endHour: end_time.split(":")[0],
      endMin: end_time.split(":")[1],
      buttonVisible: false,
      match_tags:match_tags,
    });

  }

  getDeviceGroupData() {
    const { start_time, end_time } = this.props.feed;
    this.setState({
      startHour: start_time.split(":")[0],
      startMin: start_time.split(":")[1],
      endHour: end_time.split(":")[0],
      endMin: end_time.split(":")[1],
    });

  }


  cancelConditionsHours = () => {
    this.getDeviceGroupData();
  };


  handleGroupFeedChange = (newFeed) => this.props.setFeed(newFeed);

  handleChange = (field, value) => (e) => {
    this.handleGroupFeedChange({ [field]: value });
  };

  submitConditionHours = () => {
    const { startHour, startMin, endHour, endMin } = this.state;

    if (startHour <= 9) {
      startHour = "0" + startHour;
    }

    if (startMin <= 9) {
      startMin = "0" + startMin;
    }

    if (endHour <= 9) {
      endHour = "0" + endHour;
    }

    if (endMin <= 9) {
      endMin = "0" + endMin;
    }

    let start_time = `${this.state.startHour}:${this.state.startMin}:00`;
    let end_time = `${this.state.endHour}:${this.state.endMin}:00`;

    let operationalData = {
      start_time,
      end_time,
    };

    this.setState({ loading: true });
    this.handleGroupFeedChange(operationalData, (result) => {
      if (result == 400) {
        this.cancelConditionsHours();
      }
      this.setState({ loading: false });
    });
    this.setState({ buttonVisible: false });
  };
  

  render() {
    const first = this.props.first;
    const handleChangeTag = (values) => this.props.onDeviceGroupChange(this.props.deviceGroup.id, { tags: values })
    const isTagsMaching = this.props.profile && this.props.profile.tags_matching 
    
    // GROUP TAG OPTIONS
    let default_deviceTags = []
    if(this.props.deviceGroup.tags){
      default_deviceTags = this.props.deviceGroup.tags
    }
    console.log(this.props.feed)
    var deviceTags_Options = []
    this.props.deviceTags?
    this.props.deviceTags.map((option) => {
        deviceTags_Options.push({label:option.name, value:option.id})
      })
    : null

    return (
      <div className="condition-component">
      {!this.state.buttonEnable && 
      <span
          style={{
            marginLeft: "15px",
            alignSelf: "center",
            marginTop: "2px",
            fontSize: "10px",
          }}
          className=" hide-for-mobile button secondary preview-link"
          onClick={() => {
            this.setState({ buttonEnable: !this.state.buttonEnable });
          }}
        >
          {this.props.label}
      </span>
      }
      {!this.state.buttonEnable && 
      <span
          className=" hide-for-desktop  preview-link"
          onClick={() => {
            this.setState({ buttonEnable: !this.state.buttonEnable });
          }}
        >
          <Icon
            title="Preview"
            name="cog"
            size="1.3rem"
            margin="21px 0px 6px 8px"
          />


      </span>
      }

        {this.state.buttonEnable && (
          <>
          {isTagsMaching && 
            <div className="mt-50">
             <Switch
                  label="Tags Matching"
                  checked={this.state.match_tags}
                  formId={`match_tags-1`}
                  className="flex flex-dc gap-2"
                  labelclassName="font-500"
                  size="tiny"
                  onChange={(e) => {
                    this.setState({ match_tags: e.target.checked }),
                    
                    this.handleGroupFeedChange({
                      match_tags: e.target.checked,
                    })
                    this.setState({ buttonEnable: false })


                  }}
              />
              </div>
              }
          </>
             
          
        )}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    state,
    profile: getProfile(state),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setFeed: (value) => dispatch(updateContentFeed(ownProps.feed.id, value)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PlaylistCondition);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/TagsMatchingCondition/index.js